import {useRequestHelper} from "@/helpers/request.helper";


import type {ConsultarUsuarioColaboadorQuery, ListarUsuarioColaboadorQuery} from "@/domain/queries/usuario.colaborador.query";
import type {
    AdicionarColaboradorEmpresaCommand,
    AlterarUsuarioColaboradorCommand,
    CadastrarUsuarioColaboradorCommand, RemoverColaboradorEmpresaCommand
} from "@/domain/commands/usuario.colaborador.commands";
import type {UsuarioColaboradorVm} from "@/domain/type/usuario.type";
import type {
    AlterarDispositivoUsuarioSessaoCommand,
    AlterarEmailUsuarioCommand,
    AlterarInfoUsuarioCommand, AlterarSenhaUsuarioColaboradorCommand,
    AlterarSenhaUsuarioCommand, AtivarDesativarUsuarioColaboradorCommand,
    ConfirmarEmailCommand,
    EncerrarUsuarioSessaoCommand,
    RecuperarSenhaUsaurioCommand,
    SolicitarRecuperacaoUsuarioCommand
} from "@/domain/commands/usuario.commands";


const requestHelper = useRequestHelper();


class UsuarioColaboradorService {

    consultar(query: ConsultarUsuarioColaboadorQuery) {
        return requestHelper.sendRequestPost<UsuarioColaboradorVm>('usuario/colaborador/admin/consultar', query);
    }

    gravar(command: CadastrarUsuarioColaboradorCommand) {
        return requestHelper.sendRequestPost<UsuarioColaboradorVm>('usuario/colaborador/admin/cadastrar', command);
    }

    alterar(command: AlterarUsuarioColaboradorCommand) {
        return requestHelper.sendRequestPost<UsuarioColaboradorVm>('usuario/colaborador/admin/alterar', command);
    }

    listar(query: ListarUsuarioColaboadorQuery) {
        return requestHelper.sendRequestPost<UsuarioColaboradorVm[]>('usuario/colaborador/admin/listar', query);
    }

    adicionarColaboradorEmpresa(command: AdicionarColaboradorEmpresaCommand) {
        return requestHelper.sendRequestPost<UsuarioColaboradorVm[]>('empresa/colaborador/vincular', command);
    }

    removerColaboradorEmpresa(command: RemoverColaboradorEmpresaCommand) {
        return requestHelper.sendRequestPost<UsuarioColaboradorVm[]>('empresa/colaborador/remover-vinculo', command);
    }

    consultarInfo() {
        return requestHelper.sendRequestGet<UsuarioColaboradorVm>('usuario/colaborador/info');
    }


    alterarInfoUsuario(command: AlterarInfoUsuarioCommand) {
        return requestHelper.sendRequestPost<object>('usuario/alterar/informacoes', command);
    }

    alterarSenha(command: AlterarSenhaUsuarioCommand) {
        return requestHelper.sendRequestPost<object>('usuario/alterar/senha', command);
    }


    alterarEmail(command: AlterarEmailUsuarioCommand) {
        return requestHelper.sendRequestPost<object>('usuario/alterar/email', command);
    }


    solicitarCodigoConfirmacao(cgpe:string) {
        return requestHelper.sendRequestPost<object>('usuario/solicitar/confirmacao', {cgpe:cgpe});
    }

    confirmarEmail(command: ConfirmarEmailCommand) {
        return requestHelper.sendRequestPost<object>('usuario/confirmar', command);
    }

    solicitarRecuperacaoSenha(command: SolicitarRecuperacaoUsuarioCommand) {
        return requestHelper.sendRequestPost<object>('usuario/solicitar/recuperacao', command, false);

    }

    recuperarSenha(command: RecuperarSenhaUsaurioCommand) {
        return requestHelper.sendRequestPost<object>('usuario/recuperar-senha', command, false);
    }

    listarUsuarioSessoes() {
        return requestHelper.sendRequestPost<any>('usuario/colaborador/sessao/listar', {});
    }

    alterarDispositivo(command: AlterarDispositivoUsuarioSessaoCommand) {
        return requestHelper.sendRequestPost<object>('usuario/colaborador/sessao/alterar-dispositivo', command, false);
    }

    encerrarUsuarioSessao(command: EncerrarUsuarioSessaoCommand) {
        return requestHelper.sendRequestPost<object>('usuario/colaborador/sessao/encerrar', command, true);
    }

    alterarSenhaColaborador(command: AlterarSenhaUsuarioColaboradorCommand){
        return requestHelper.sendRequestPost<string>('usuario/colaborador/alterar/senha/usuario', command);
    }
    ativarUsuarioColaborador(command: AtivarDesativarUsuarioColaboradorCommand){
        return requestHelper.sendRequestPost<string>('usuario/colaborador/ativar_usuario', command);
    }
    desativarUsuarioColaborador(command: AtivarDesativarUsuarioColaboradorCommand){
        return requestHelper.sendRequestPost<string>('usuario/colaborador/desativar_usuario', command);
    }

}

export default new UsuarioColaboradorService();